import { render, staticRenderFns } from "./SuccessStoryEdit.vue?vue&type=template&id=70d3260e&scoped=true&"
import script from "./SuccessStoryEdit.vue?vue&type=script&lang=js&"
export * from "./SuccessStoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./SuccessStoryEdit.vue?vue&type=style&index=0&id=70d3260e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3260e",
  null
  
)

export default component.exports